export const CommonStackTokens = { childrenGap: 8 };
